<script setup lang="ts">
export interface Props {
  item: {
    text: string;
    title: string;
    data: {
      close?: () => void;
      dangerouslySetInnerHtmlText?: string;
    };
    type: 'success' | 'info' | 'warning' | 'error';
  };
  close: () => void;
}
const props = withDefaults(defineProps<Props>(), {});

function handleClick(): void {
  if (props.item.data.close) props.item.data.close();
  props.close();
}
</script>

<template>
  <div
    :class="[
      'vue-notification-template',
      $style.appNotification,
      $style[`type_${props.item.type}`],
      { 'cursor-pointer': !!props.item.data.close },
    ]"
    @click="handleClick"
  >
    <div v-if="props.item.title" :class="$style.title">
      {{ props.item.title }}
    </div>
    <div
      v-if="props.item.data.dangerouslySetInnerHtmlText || props.item.text"
      :class="$style.content"
    >
      <!-- eslint-disable vue/no-v-html -->
      <span
        v-if="!!props.item.data.dangerouslySetInnerHtmlText"
        v-html="props.item.data.dangerouslySetInnerHtmlText"
      />
      <!-- eslint-enable vue/no-v-html -->
      <span v-else>
        {{ props.item.text }}
      </span>
    </div>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.appNotification {
  margin: variables.$pageMarginX calc(variables.$pageMarginX / 2) 1px 0;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 1px 1px 1px colors.$color-border-input-hovered;

  &.type_success {
    background-color: colors.$color-status-success-icon;
    color: colors.$color-white;
  }
  &.type_info {
    background-color: colors.$color-text-tertiary;
  }
  &.type_warning {
    background-color: colors.$color-yellow-500;
  }
  &.type_error {
    background-color: colors.$color-red-700;
    color: colors.$color-white;
  }
}

  .title {
    font-size: 16px;
    line-height: 100%;
    font-weight: 500;
  }

  .content {
    font-size: 14px;
    line-height: 100%;
  }

  .title + .content {
    margin-top: 10px;
  }
</style>
